import { render, staticRenderFns } from "./ossStats.vue?vue&type=template&id=b92e3296"
import script from "./ossStats.vue?vue&type=script&lang=js"
export * from "./ossStats.vue?vue&type=script&lang=js"
import style0 from "./ossStats.vue?vue&type=style&index=0&id=b92e3296&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports